import { useField } from "formik"
import { Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { NullableCalendarEvent } from "../../resource/calendar/fullCalendarTypes"
import { DeliveryTimesField, DynamicConfigKey } from "../../form/formTypes"
import { MeetingServices } from "./MeetingServices"
import { CreateOrderType } from "../../../helpers"
import { Resources } from "./Resources"

type OrderSummaryProps = Readonly<{
    isRefundOrder: boolean
    isUpdatable: boolean
    orderType: CreateOrderType
}>

export function OrderSummaryContent({ isRefundOrder, isUpdatable, orderType }: OrderSummaryProps) {
    const [{ value: deliveries }] = useField<DeliveryTimesField | undefined>(DynamicConfigKey.MULTIPLE_DELIVERIES)
    const [{ value: event }] = useField<NullableCalendarEvent>("event")

    const hasResources = !!event?.resourceIds?.length

    const hasMeetingServices = deliveries?.deliveryTimes
    const shouldShowEmptyState = !hasResources && !hasMeetingServices

    return (
        <>
            {hasResources && !isRefundOrder && <Resources isUpdatable={isUpdatable} />}
            {hasMeetingServices && (
                <MeetingServices
                    isRefundOrder={isRefundOrder}
                    isEditable={orderType === CreateOrderType.MEETING_SERVICE}
                />
            )}
            {shouldShowEmptyState && (
                <LocalizedStrict id="create-order-order-summary-no-items">
                    <Typography variant="body1">
                        Order summary is currently empty. Add items to your order to see the details.
                    </Typography>
                </LocalizedStrict>
            )}
        </>
    )
}
